export const mutations = {
    setAdCar(state, adCar){
        state.adCar = adCar;
    },
    setAccessToken(state, accessToken){
        state.auth.accessToken = accessToken;
    },
    setLoggedUser(state, user){
        state.auth.loggedUser = user;
    },
    setCurrency(state, currency){
        state.currency = currency;
    },
    setCurrencies(state, currencies){
        state.currencies = currencies;
    },
    setLocale(state, locale){
        state.locale = locale;
    },
    setAlert(state, alert){
        state.alert = alert;
    },
    setAppName(state, level){
        state.appName = level;
    },
    setAppVersion(state, level){
        state.appVersion = level;
    },
    setBuildTime(state, level){
        state.buildTime = level;
    },
    setUiConf(state, level){
        state.uiConf = level;
    }
};
